/* script */
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

// Components
import BaseControl from 'shared/ui/components/form-components/BaseControl.vue';

/**
 * Text component to wrap inputs with autocomplete.
 *
 * It has all `BaseControl` options plus:
 *
 * @vue-prop {String[]} [suggestions=[]] the suggestions to feed the typeahead
 *
 * @example
 *
 * input-autocomplete(:label="t('name')" type="text" v-model="form.name" :suggestions="mySuggestions" name="name")
 *
 * @category shared.ui.components.form-components
 * @exports InputAutocomplete
 * @component
 */
const __vue_script__ = {
    name: 'InputAutocomplete',

    extends: BaseControl,

    props: {
        type: {
            type: String,
            default: 'text'
        },

        value: {
            type: [String, Number],
            default: null
        },

        placeholderIconClass: {
            type: String,
            default: null
        },

        hideErrors: {
            type: Boolean,
            default: false
        },

        suggestions: {
            type: Array,
            default: () => []
        },

        trackBy: {
            type: String,
            default: null
        },

        altTrackBy: {
            type: String,
            default: null
        },

        limit: {
            type: Number,
            default: 4
        },

        minChars: {
            type: Number,
            default: 3
        },

        cleanAfter: {
            type: Boolean,
            default: false
        },

        anchor: {
            type: String,
            default: null
        },

        emitOnBlur: {
            type: Boolean,
            default: true
        },

        showPerfectMatch: {
            type: Boolean,
            default: false
        }
    },

    data() {
        return {
            current: -1,
            items: [],
            searchTerm: ''
        };
    },

    computed: {
        // Pass-through listeners
        listeners() {
            // Here we skip the `input` and `change` listeners, since we provide our own
            // and we don't want it to be overwritten.

            // eslint-disable-next-line
            const { input, keydown, ...listeners } = this.$listeners;

            return listeners;
        },

        decoratorErrors() {
            return this.hideErrors ? undefined : this.errors;
        },

        hasItems() {
            return this.items.length > 0;
        },

        hasQuery() {
            return Boolean(this.searchTerm.length);
        },

        showSuggestions() {
            if (!this.hasQuery || !this.hasItems) {
                return false;
            }

            return this.showPerfectMatch ? this.matchesSuggestion : !this.matchesSuggestion;
        },

        matchesSuggestion() {
            return this.hasQuery && this.suggestions.some(s => this.match(s, this.searchTerm, !this.showPerfectMatch));
        },

        showGhost() {
            return this.hasQuery && this.ghost !== this.searchTerm && this.suggestions.some(s => this.match(s, this.searchTerm));
        },

        ghost() {
            const ghost = this.suggestions.find(s => this.match(s, this.searchTerm));

            if (typeof ghost === 'object') {
                if (ghost[this.trackBy].startsWith(this.searchTerm)) {
                    return ghost[this.trackBy];
                } else {
                    return ghost[this.altTrackBy];
                }
            }

            return ghost || '';
        }
    },

    watch: {
        suggestions(value) {
            if (value.length) {
                this.update();
            }
        }
    },

    created() {
        this.searchTerm = this.value || '';
    },

    methods: {
        reset() {
            this.items = [];
            this.searchTerm = '';
        },

        setSelected(index) {
            this.current = index;
        },

        selectItem(item) {
            if (!item) {
                return;
            }

            this.searchTerm = this.trackBy ? item[this.trackBy] : item;
            this.emit();
        },

        emit() {
            this.$emit('input', this.searchTerm);
            if (this.cleanAfter) {
                this.searchTerm = '';
            }
        },

        onUp() {
            if (this.current > 0) {
                this.current--;
            } else if (this.current === -1) {
                this.current = this.items.length - 1;
            } else {
                this.current = -1;
            }
        },

        onDown() {
            if (this.current < this.items.length - 1) {
                this.current++;
            } else {
                this.current = -1;
            }
        },

        onEnter() {
            if (!this.hasItems) return;

            if (this.current !== -1) {
                this.selectItem(this.items[this.current]);
            } else {
                this.selectItem(this.items[0]);
            }
        },

        onBlur() {
            if (this.emitOnBlur) {
                this.emit();
            }
        },

        update() {
            if (!this.searchTerm) {
                this.reset();
                return;
            }

            if (this.minChars && this.searchTerm.length < this.minChars) {
                return;
            }

            let data = this.suggestions.filter(s => this.match(s, this.searchTerm));

            if (!data.length) {
                data = this.suggestions.filter(s => this.match(s, this.searchTerm, true));
            }

            this.items = this.limit ? data.slice(0, this.limit) : data;
            this.current = -1;
        },

        match(item, search, exactMatch = false) {
            if (!item) return false;

            if (typeof item === 'string') {
                const term = item.toLocaleLowerCase();
                const q = search.toLocaleLowerCase();
                return exactMatch ? term === q : term.startsWith(q);
            } else {
                let match = this.match(item[this.trackBy], search, exactMatch);

                if (this.altTrackBy && !match) {
                    match = this.match(item[this.altTrackBy], search, exactMatch);
                }

                return match;
            }
        }
    }
};

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('control-decorator',{staticClass:"with-autocomplete",attrs:{"label":_vm.label,"tip":_vm.tip,"hint":_vm.hint,"uid":_vm.uid,"errors":_vm.decoratorErrors,"hint-after-label":_vm.hintAfterLabel,"warning":_vm.warning,"dependant":_vm.dependant},scopedSlots:_vm._u([{key:"after-label",fn:function(ref){return [_vm._t("after-label")]}},{key:"default",fn:function(ref){
var _obj;
return [_c('div',{staticClass:"input-wrapper",class:{'with-content': _vm.$slots.default}},[(_vm.placeholderIconClass)?_c('i',{staticClass:"input-left-icon",class:_vm.placeholderIconClass}):_vm._e(),((_vm.type)==='checkbox')?_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],ref:"input",staticClass:"form-control",class:{'has-error': _vm.errors.length, 'has-warning': _vm.warning, 'with-icon': !!_vm.placeholderIconClass},attrs:{"id":_vm.uid,"name":_vm.name,"disabled":_vm.disabled,"autocomplete":"off","placeholder":_vm.placeholder,"aria-label":_vm.placeholder && !_vm.label ? _vm.placeholder : null,"type":"checkbox"},domProps:{"checked":Array.isArray(_vm.searchTerm)?_vm._i(_vm.searchTerm,null)>-1:(_vm.searchTerm)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.onDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.onUp.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.selectItem(_vm.items[0])},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.onEnter.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.reset.apply(null, arguments)}],"keyup":function($event){return _vm.$emit('change', _vm.searchTerm)},"blur":_vm.onBlur,"input":_vm.update,"change":function($event){var $$a=_vm.searchTerm,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.searchTerm=$$a.concat([$$v]))}else{$$i>-1&&(_vm.searchTerm=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.searchTerm=$$c}}}},'input',_vm.$attrs,false),_vm.listeners)):((_vm.type)==='radio')?_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],ref:"input",staticClass:"form-control",class:{'has-error': _vm.errors.length, 'has-warning': _vm.warning, 'with-icon': !!_vm.placeholderIconClass},attrs:{"id":_vm.uid,"name":_vm.name,"disabled":_vm.disabled,"autocomplete":"off","placeholder":_vm.placeholder,"aria-label":_vm.placeholder && !_vm.label ? _vm.placeholder : null,"type":"radio"},domProps:{"checked":_vm._q(_vm.searchTerm,null)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.onDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.onUp.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.selectItem(_vm.items[0])},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.onEnter.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.reset.apply(null, arguments)}],"keyup":function($event){return _vm.$emit('change', _vm.searchTerm)},"blur":_vm.onBlur,"input":_vm.update,"change":function($event){_vm.searchTerm=null}}},'input',_vm.$attrs,false),_vm.listeners)):_c('input',_vm._g(_vm._b({directives:[{name:"model",rawName:"v-model",value:(_vm.searchTerm),expression:"searchTerm"}],ref:"input",staticClass:"form-control",class:{'has-error': _vm.errors.length, 'has-warning': _vm.warning, 'with-icon': !!_vm.placeholderIconClass},attrs:{"id":_vm.uid,"name":_vm.name,"disabled":_vm.disabled,"autocomplete":"off","placeholder":_vm.placeholder,"aria-label":_vm.placeholder && !_vm.label ? _vm.placeholder : null,"type":_vm.type},domProps:{"value":(_vm.searchTerm)},on:{"keydown":[function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"down",40,$event.key,["Down","ArrowDown"])){ return null; }return _vm.onDown.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"up",38,$event.key,["Up","ArrowUp"])){ return null; }return _vm.onUp.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"right",39,$event.key,["Right","ArrowRight"])){ return null; }if('button' in $event && $event.button !== 2){ return null; }return _vm.selectItem(_vm.items[0])},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"enter",13,$event.key,"Enter")){ return null; }$event.preventDefault();return _vm.onEnter.apply(null, arguments)},function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"esc",27,$event.key,["Esc","Escape"])){ return null; }return _vm.reset.apply(null, arguments)}],"keyup":function($event){return _vm.$emit('change', _vm.searchTerm)},"blur":_vm.onBlur,"input":[function($event){if($event.target.composing){ return; }_vm.searchTerm=$event.target.value},_vm.update]}},'input',_vm.$attrs,false),_vm.listeners)),_vm._t("default"),_c('div',{staticClass:"ghost",class:{ in: _vm.showGhost }},[_vm._v(_vm._s(_vm.ghost))])],2),_c('div',{staticClass:"dropdown",class:{ in: _vm.showSuggestions }},[_c('div',{staticClass:"menu-wrapper"},[_c('div',{staticClass:"menu dropdown-vue visible",class:( _obj = {}, _obj[_vm.anchor] = _vm.anchor, _obj )},[_c('ul',_vm._l((_vm.items),function(item,index){return _c('li',{class:{ selected: _vm.current === index },on:{"mousedown":function($event){return _vm.selectItem(item)},"mousemove":function($event){return _vm.setSelected(index)}}},[(_vm.$scopedSlots['item'])?_vm._t("item",null,{"item":item,"index":index,"selectItem":_vm.selectItem}):_c('a',{domProps:{"textContent":_vm._s(item.name || item)},on:{"click":function($event){return _vm.selectItem(item)}}})],2)}),0)])])])]}}],null,true)})}
var __vue_staticRenderFns__ = []

  /* style */
  const __vue_inject_styles__ = undefined
  /* scoped */
  const __vue_scope_id__ = undefined
  /* module identifier */
  const __vue_module_identifier__ = undefined
  /* functional template */
  const __vue_is_functional_template__ = false
  /* component normalizer */
  function __vue_normalize__(
    template, style, script,
    scope, functional, moduleIdentifier, shadowMode,
    createInjector, createInjectorSSR, createInjectorShadow
  ) {
    const component = (typeof script === 'function' ? script.options : script) || {}

    // For security concerns, we use only base name in production mode.
    component.__file = "InputAutocomplete.vue"

    if (!component.render) {
      component.render = template.render
      component.staticRenderFns = template.staticRenderFns
      component._compiled = true

      if (functional) component.functional = true
    }

    component._scopeId = scope

    if (false) {
      let hook
      if (false) {
        // In SSR.
        hook = function(context) {
          // 2.3 injection
          context =
            context || // cached call
            (this.$vnode && this.$vnode.ssrContext) || // stateful
            (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
          // 2.2 with runInNewContext: true
          if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
            context = __VUE_SSR_CONTEXT__
          }
          // inject component styles
          if (style) {
            style.call(this, createInjectorSSR(context))
          }
          // register component module identifier for async chunk inference
          if (context && context._registeredComponents) {
            context._registeredComponents.add(moduleIdentifier)
          }
        }
        // used by ssr in case component is cached and beforeCreate
        // never gets called
        component._ssrRegister = hook
      }
      else if (style) {
        hook = shadowMode 
          ? function(context) {
              style.call(this, createInjectorShadow(context, this.$root.$options.shadowRoot))
            }
          : function(context) {
              style.call(this, createInjector(context))
            }
      }

      if (hook !== undefined) {
        if (component.functional) {
          // register for functional component in vue file
          const originalRender = component.render
          component.render = function renderWithStyleInjection(h, context) {
            hook.call(context)
            return originalRender(h, context)
          }
        } else {
          // inject component registration as beforeCreate hook
          const existing = component.beforeCreate
          component.beforeCreate = existing ? [].concat(existing, hook) : [hook]
        }
      }
    }

    return component
  }
  /* style inject */
  
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    undefined,
    undefined,
    undefined
  )

  export default __vue_component__